import { useEffect, useRef } from "react";

import SmallCaption from "../_components/small-caption/SmallCaption";
import Link from "../_components/link/Link";

import "./Footer.css";

import { WHITE_LOGO, CHECK, SPIRAL, BLACK_LINES } from "../_media/assets";
import createAnimation from "../_utils/createAnimation";
import { PSYCHOLOGY_TODAY } from "../_utils/links";

const Footer = () => {
  const ref = useRef(null);

  useEffect(() => createAnimation(ref), []);

  const goToPsychologyToday = () => window.open(PSYCHOLOGY_TODAY)
  return (
    <footer className="Footer" ref={ref}>
      <section className="Footer-top">
        <img className="Footer-logo" src={WHITE_LOGO} alt="logo" />
        <section className="Footer-menus">
          <section className="Footer-menu">
            <SmallCaption color="#D8468B" text="VESTA HEALING" />
            <Link link="/">Home</Link>
            <Link link="/about-me">About Me</Link>
            <Link link="/services">Services</Link>
          </section>
          <section className="Footer-menu">
            <SmallCaption color="#D8468B" text="COMPANY" />
            <Link link="/">Contact Us</Link>
          </section>
        </section>
        <img className="Footer-lines" src={BLACK_LINES} alt="" />
      </section>
      <section className="Footer-bottom">
        <span className="Footer-bottom-text verified" onClick={goToPsychologyToday}>
          <img src={CHECK} alt="" /> Verified by Psychology Today
        </span>
        <span className="Footer-bottom-text">
          <img src={SPIRAL} alt="" /> Copyright &copy; {new Date().getFullYear()} Clarity Healing
          Psychotherapy. All rights reserved. 
        </span>
      </section>
    </footer>
  );
};

export default Footer;
